// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import { sync } from 'vuex-router-sync';
import 'es6-promise/auto'; // for IE11 when use Axios and esri-loader
import 'es6-object-assign/auto'; // for IE11 when use vue-js-modal
import router from './router';
import store from './store';
// eslint-disable-next-line
// import 'tachyons-debug'; // causes eslint import/extension errors

import App from './App';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.EnableDevTools;
Vue.use(Notifications); // component name: notifications
Vue.use(VModal); // component name: modal
// Vue.use(ElementUI);


sync(store, router);
/* eslint-disable no-new */
const app = new Vue({
  router,
  store,
  components: { App },
  template: '<App/>',
});

// work around to get vue devtools to capture initial vuex commits on startup
// https://github.com/vuejs/vue-devtools/issues/408#issuecomment-349297890
if (process.env.NODE_ENV !== 'production') {
  setTimeout(() => { app.$mount('#app'); }, 500);
} else {
  app.$mount('#app');
}



// WEBPACK FOOTER //
// ./src/main.js